import { useTranslation } from "react-i18next";
import MagneticTravelRtPanel from "./MagneticTravelRtPanel";

const socd = (props: any) => {
  const {
    checkData,
    getAfterChangeData,
    isMagnetic = false,
    keyboardType,
  } = props;
  const wizardSteps = checkData?.wizard?.steps ?? [];

  const { t } = useTranslation();

  const translateSocdModeLabel = (key: string): string => {
    switch (key) {
      case "keyboard.advancedKey.socdModes.modeOptions.triggerLast":
        return t("keyboard.advancedKey.socdModes.modeOptions.triggerLast");
      case "keyboard.advancedKey.socdModes.modeOptions.triggerLastDesc":
        return t("keyboard.advancedKey.socdModes.modeOptions.triggerLastDesc");
      case "keyboard.advancedKey.socdModes.modeOptions.priority1":
        return t("keyboard.advancedKey.socdModes.modeOptions.priority1");
      case "keyboard.advancedKey.socdModes.modeOptions.priority1Desc":
        return t("keyboard.advancedKey.socdModes.modeOptions.priority1Desc");
      case "keyboard.advancedKey.socdModes.modeOptions.priority2":
        return t("keyboard.advancedKey.socdModes.modeOptions.priority2");
      case "keyboard.advancedKey.socdModes.modeOptions.priority2Desc":
        return t("keyboard.advancedKey.socdModes.modeOptions.priority2Desc");
      case "keyboard.advancedKey.socdModes.modeOptions.cancel":
        return t("keyboard.advancedKey.socdModes.modeOptions.cancel");
      case "keyboard.advancedKey.socdModes.modeOptions.cancelDesc":
        return t("keyboard.advancedKey.socdModes.modeOptions.cancelDesc");
      default:
        return "";
    }
  };
  const translatedModeOptions =
    checkData.modeOptions?.map((option: any) => ({
      ...option,
      label: translateSocdModeLabel(option.labelKey),
      desc: translateSocdModeLabel(option.descKey),
    })) || [];

  const getSocdMode = (value: number | string) => {
    const newCheckData = JSON.parse(JSON.stringify(checkData));
    newCheckData.otherData.mode = value;
    getAfterChangeData(newCheckData);
  };

  return (
    <>
      <div className="advance-setting-box">
        <div className="advance-setting-box-header">
          <div className="advance-setting-box-header-title">
            {wizardSteps[1]?.titleKey ? t(wizardSteps[1].titleKey) : ""}
          </div>
          <div className="advance-setting-box-header-desc">
            {wizardSteps[1]?.descKey ? t(wizardSteps[1].descKey) : ""}
          </div>
        </div>
        <div className="operation-item operation-socd">
          <div className="socd-mode-box-step">
            {translatedModeOptions.map((item: any) => {
              return (
                <div
                  className={`socd-mode-item ${checkData.otherData.mode === item.value ? "active" : ""}`}
                  key={item.value}
                  onClick={() => getSocdMode(item.value)}
                >
                  <div className="socd-mode-item-text">{item.label}</div>
                  <div className="socd-mode-item-text desc">{item.desc}</div>
                  {checkData.otherData.mode === item.value && (
                    <div className="socd-mode-item-checked">
                      <svg
                        className="checked-icon"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13.5 4.5L6 12L2.5 8.5"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
      {isMagnetic ? (
        <MagneticTravelRtPanel
          checkData={checkData}
          getAfterChangeData={getAfterChangeData}
          showRt
          keyboardType={keyboardType}
        />
      ) : null}
    </>
  );
};
export default socd;
